import React, { Fragment, useContext, useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import ExitModalAndSave from '../Modal/ExitModalAndSave';
import Button from "../../Button/Button";
import { useDispatch, useSelector } from 'react-redux';
import { userChosenVandalismQuestion, DMCChecksavedAnswer } from '../../ducks/redux/actions/userChoices';
import { useTranslation } from 'react-i18next';
import { WorksOrderRequest } from '../../models/WorksOrders/WorksOrderRequest';
import classes from "../UploadMedia/styles.module.scss";
import styles from "../UploadMedia/spinner.module.scss";
import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import './index.css';
import * as api from "../../api";
import Message from '../../storybook/Message';
import BackModal from '../Modal/BackModal';
import HeaderJourney from '../../storybook/Header/HeaderJourney';
import { FeatureFlags } from '../contexts/FeatureFlags';
import { workOrderRepairObject } from '../../ducks/redux/actions/getAddress';
import { RemoveAllDMCData } from '../../ducks/redux/actions/FinancialReferral';

interface ConfirmedDampMouldProps extends RouteComponentProps<any> {

}

const ConfirmedDampMould: React.FC<ConfirmedDampMouldProps> = (props: any) => {
  const savedAnswer = useSelector((state: any) => state?.userChoicesReducer?.DMCChecksavedAnswer);
  const [isLoading, setIsLoading] = useState(false);
  const [selAns, setSelAns] = useState("");
  const assetByIdDataObject = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const vandalismConfigValue = useSelector((state: any) => state?.userChoicesReducer?.vandalismtoggleValue);
  const isRepairMedia = useSelector((state: any) => state?.userChoicesReducer?.isRepairMediaAllowed);
  const workOrderObject = useSelector((state: any) => state.addresses?.workOrderRepair);
  const { featureMedia }: any = useContext(FeatureFlags);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [error, setError] = useState("");

  const exitButtonHandler = () => {
    props.history.push("/customer360View");
  };

  const saveDraftAndExit = () => {
    //   dispatch(userChosenSaveExit(true))   
    UpdateWorkOrder();
    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderRepairObject(worksOrder))
    props.history.push("/customer360View");
  };
  const backButtonHandler = () => {
    props.history.push("/RepairAdditionalDetails");
  }

  const UpdateWorkOrder = async () => {
    try {
      setIsLoading(true);
      workOrderObject.isCausingDampAndMould = selAns === "Yes" ? true : false;
      const assessmentInformation = null
      workOrderObject.assessmentInformation = assessmentInformation;
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);

      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject.id,
        "eTag"
      )

    } catch (e) {
      console.error(e);
      props.history.push("/GenericError");
    } finally {
      setIsLoading(false);
    }
  };

  const handleContinue = () => {
    if (selAns === "") {
      setError("Please answer all the questions to continue.");
      return;
    }

    setError("");
    dispatch(DMCChecksavedAnswer(selAns)); // Save the selected answer to Redux
    UpdateWorkOrder();
    if (selAns === "Yes") {
      props.history.push("/DampAndMouldAssesment/1");
    } else if (featureMedia === "true") {
      dispatch(RemoveAllDMCData(null))
      props.history.push("/Uploadmedia");
    } else if (assetByIdDataObject?.statuses.isInDefects && vandalismConfigValue) {
      dispatch(RemoveAllDMCData(null))
      props.history.push("/VandalismQuestion");
    } else {
      dispatch(userChosenVandalismQuestion(""));
      dispatch(RemoveAllDMCData(null))
      props.history.push("/VulnerabilityQuestion");
    }
  };
  useEffect(() => {
    if (savedAnswer) {
      setSelAns(savedAnswer); // Restore the selected answer when coming back
    }
  }, [savedAnswer]);


  const updateSelection = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setSelAns(e.target.value); //
  }

  return (<>
    <HeaderJourney></HeaderJourney>
    <div className="container-fluid parent-footer repair-request p-0" id="repAddDet-container">

      {isLoading ? (
        <div className={classes.overlay}>
          <div id="UploadingOverlay">
            <div className={styles.overlayContainer}>
              <div className={styles.overlayContent}>
                <div className={styles.spinner}></div>
              </div>
            </div>
          </div>
        </div>
      ) :
        (
          <Fragment>
            <div
              id="repAddDet-main-div"
              className="padding-repair"
            >

              <div id="repAddDet-div1">
                <h1 className="header-size pb-30" id="DMCcheck-h1">
                  {t("DMC_Question")}</h1>
                <div>
                  <RadioGroup
                    role="radiogroup"
                    name="radio-buttons-group"
                    className="margin-radiogroup"
                    value={selAns}
                    onChange={updateSelection}
                    data-testid="sureradioValue"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio className="radio-yes" id="yes-radio" />}
                      label="Yes"
                      className='wid-radio'
                      data-testid="yesRadio"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio className="radio-no" id="no-radio" />}
                      label="No"
                      className='wid-radio'
                      data-testid="noRadio"
                    />
                  </RadioGroup>
                </div>
                {selAns === "Yes" && (
                  <div role="alert" className="additional-infomsg">
                    <Message className="info-msg">
                      {t("damp_Mould_Message")}
                    </Message>
                  </div>
                )}
                {(error !== "") && <Message className="error-msg">{t(error)} </Message>}
              </div> </div>

            <div className="col-md-12 marginTop-auto" id="repAddDet-div5">
              <div className="row m-0 footer-actionbtn">
                <div className="col btn-top padding-repair mb-0">

                  <BackModal id="repAddDet-backmodal" back={backButtonHandler} />
                  <ExitModalAndSave
                    id="custDetails-exitmodal"
                    exit={exitButtonHandler}
                    saveDraftAndExit={saveDraftAndExit}
                  // closeAfterSaving={closeAfterSaving}
                  />
                </div>
                <div className="col text-end pt-24 padding-repair">
                  <Button
                    id="btn_additionaldetails"
                    onClick={handleContinue}
                    onKeyDown={handleContinue}
                    className="primary-btn"
                  >
                    {t("continuen_button")}{" "}
                  </Button>
                </div>

              </div>
            </div>
          </Fragment>)}
    </div>
  </>
  );
};
export default ConfirmedDampMould;